import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';
import {TableFilter} from '../api/table-filter';

export class WebTradeOrderView {
  @JsonProperty()
  id: number = -1;

  @JsonProperty()
  userName: string | undefined;

  @JsonProperty()
  viewName: string | undefined;

  @JsonProperty()
  template: string | undefined;

  @JsonProperty()
  sortOrder: number = -1;

  @JsonProperty()
  visible: boolean = true;

  @JsonProperty()
  showOption: WebTradeOrderView.SHOW_OPTION = WebTradeOrderView.SHOW_OPTION.BOTH;

  @JsonProperty()
  commonFilters: TableFilter[] = []

  @JsonProperty()
  tradeFilters: TableFilter[] = []

  @JsonProperty()
  orderFilters: TableFilter[] = []

  @JsonProperty()
  modificationDate: DateTime = DateTime.now();

  @JsonProperty()
  creationDate: DateTime = DateTime.now();

  viewIco: string | undefined;

  public static toFilters(origin: string, view: WebTradeOrderView): TableFilter[] {
    const filters: TableFilter[] = [];
    if (view && view.commonFilters) {
      view.commonFilters.forEach(filter => {
        filters.push(...this.getFieldFilter(filter));
      });
    }
    if (WebTradeOrderView.ORIGIN.TRADE === origin || WebTradeOrderView.ORIGIN.TRADE_AGG === origin) {
      if (view && view.tradeFilters) {
        view.tradeFilters.forEach(filter => {
          filters.push(...this.getFieldFilter(filter));
        });
      }
    } else {
      if (view && view.orderFilters) {
        view.orderFilters.forEach(filter => {
          filters.push(...this.getFieldFilter(filter));
        });
      }
    }
    return filters;
  }

  private static getFieldFilter(filter: TableFilter): TableFilter[] {
    const filters: TableFilter[] = [];
    if (filter.value) {
      filters.push(filter);
    }
    return filters;
  }

  public static getFilterValue(view: WebTradeOrderView, field: string): string {
    if (view.commonFilters) {
      const filter: TableFilter = view.commonFilters.find(value => value.field == field);
      if (filter) {
        return filter.value;
      }
    }

    if (view.orderFilters) {
      const filter: TableFilter = view.orderFilters.find(value => value.field == field);
      if (filter) {
        return filter.value;
      }
    }

    if (view.tradeFilters) {
      const filter: TableFilter = view.tradeFilters.find(value => value.field == field);
      if (filter) {
        return filter.value;
      }
    }
    return '';
  }
}

export module WebTradeOrderView {
  export enum SHOW_OPTION {
    BOTH = 'BOTH',
    ORDER_ONLY = 'ORDER_ONLY',
    TRADE_ONLY = 'TRADE_ONLY',
  }

  export enum ORIGIN {
    TRADE = 'trade',
    TRADE_AGG = 'trade_agg',
    ORDER = 'order',
    ORDER_CLEARING = 'order_clearing',
  }
}
